export const translateStatus = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'pending':
      return 'Pendiente';
    case 'accepted':
      return 'Aceptado';
    case 'assigned':
      return 'Asignado';
    case 'progress':
      return 'En Progreso';
    case 'complete':
      return 'Completo';
    case 'rejected':
      return 'Rechazado';
    default:
      return status;
  }
};
